export const buildIdempotencyKey = (prefix: string): string => {
  try {
    if (typeof globalThis.crypto?.randomUUID === 'function') {
      return `${prefix}-${globalThis.crypto.randomUUID()}`;
    }
  } catch {
    // Use fallback below when crypto is unavailable or blocked.
  }

  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(16).slice(2, 10)}`;
};
